module.exports = __webpack_public_path__ + "icon_integration.e54d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_integration.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_integration.svg
// module chunks = main